var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStakeSuccess = function SvgStakeSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stake-success_svg__a)",
    strokeWidth: 6.851,
    d: "M72.375 36.404c0 17.794-14.3 32.17-31.881 32.17-17.582 0-31.882-14.376-31.882-32.17s14.3-32.17 31.882-32.17c17.58 0 31.881 14.376 31.881 32.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "url(#stake-success_svg__b)",
    strokeWidth: 6.851,
    d: "M67.388 35.596c0-17.794-14.3-32.17-31.881-32.17S3.626 17.801 3.626 35.595s14.3 32.17 31.88 32.17c17.582 0 31.882-14.376 31.882-32.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F54EC",
    d: "M22.744 27.483a3.425 3.425 0 0 0-5.195 4.466zM36.353 48.57l-2.598 2.233 2.318 2.697 2.608-2.418zm-18.804-16.62 16.206 18.853 5.195-4.466-16.206-18.853zm21.132 19.132 38.646-35.82-4.657-5.025-38.646 35.82z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-success_svg__c)",
    d: "M24.546 24.894a3.425 3.425 0 1 0-5.06 4.617zm11.807 18.02-2.53 2.308 2.32 2.542 2.53-2.332zM19.486 29.51l14.336 15.711 5.06-4.618-14.336-15.71zm19.187 15.921 36.153-33.306-4.642-5.039-36.152 33.307z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-success_svg__a",
    x1: 40.494,
    x2: 40.494,
    y1: 0.808,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A56F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#B7379A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-success_svg__b",
    x1: 39.469,
    x2: 35.442,
    y1: 100.1,
    y2: 0.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-success_svg__c",
    x1: 47.884,
    x2: 47.884,
    y1: 7.093,
    y2: 39.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A56F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#B7379A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB970"
  })))));
};
export default SvgStakeSuccess;